<div class="container">
  <div class="section">
    <div class="flex-space-between">
      <div>
        <h5>Step 1: Load files to share</h5>
        <h6>Add up to 50 GB</h6>
      </div>
      <div>
        <button class="vlr-primary-btn" (click)="fileUpload.click()">Add Files</button>
      </div>
    </div>
    <div style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 12px; margin-bottom: 16px; border-radius: 4px;">
      <mat-icon style="vertical-align: middle; color: #ff9800; margin-right: 8px;">warning</mat-icon>
      <span style="color: #856404; font-weight: 500;">
        Important: Do not refresh or navigate away from this page during large file uploads. 
        Closing this page will interrupt the upload and you will need to restart.
      </span>
    </div>
    <input type="file" class="file-input"
           multiple
           [accept]="requiredFileType"
           (change)="onFileSelected($event)" #fileUpload>
    <div class="drag-and-drop" appDragAndDrop (fileDropped)="onFileDropped($event)" (click)="fileUpload.click()" style="cursor: pointer;">
      <div class="drag-and-drop-text">Or drop file here to instantly load it</div>
      <img src="assets/img/upload.svg" alt="Upload" class="upload-img">
    </div>
  </div>

  <mat-divider class="m-3"></mat-divider>
  <h5>Step 2: Share the files</h5>
  <app-uploads-status (shareFileListEvent)="toggleShare($event)"></app-uploads-status>
</div>

<button class="vlr-large-cta-btn vlr-icon-btn vlr-sticky-btn"
        (click)="$event.stopPropagation();openShareDialog()"
        [disabled]="isShareDisabled">
  <mat-icon>share</mat-icon><span>Share Files</span>
</button>


